export const paginationInit = {
  current: 1,
  next: 2,
  prev: 0,
  take: 10,
  total: 0,
};

export const pagination = {
  current: 1,
  next: 2,
  prev: 0,
  take: 10,
  total: 0,
};

export const skeletonList = () =>
  new Array(10).fill('').map((e, idx) => {
    return {
      key: idx,
    };
  });

export const orderList = [
  { key: '0', value: 'createdAt', name: 'Sắp theo ngày tạo' },
  { key: '1', value: 'name', name: 'Sắp theo Alphabet' },
];

export const statusList = [
  { key: 'all', value: 'all', name: 'Tất cả trạng thái' },
  { key: '0', value: 0, name: 'Đang hoạt động' },
  { key: '1', value: 1, name: 'Dừng hoạt động' },
];
